export default __webpack_public_path__ + "static/media/6.cfd6f835.png";